var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", "z-index": "600" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-chip",
                _vm._g(
                  { attrs: { color: _vm.color, "text-color": _vm.textColor } },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "small mr-1 my-2" }, [
                    _vm._v("fa-car")
                  ]),
                  _vm._v(_vm._s(_vm.text))
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        [
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("travelService.types.car")) +
                " (" +
                _vm._s(_vm.$t("global.request")) +
                ")"
            )
          ]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.pickupPlace")) +
              ": " +
              _vm._s(_vm.startPlaceText)
          ),
          _c("br"),
          _vm._v(
            " " + _vm._s(_vm.$t("travelService.returnDifferentPlace")) + " "
          ),
          _vm.travelServiceOrderItem.car.end_place_id !== null
            ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
                _vm._v("fa-check")
              ])
            : _c("v-icon", { attrs: { small: "", color: "error" } }, [
                _vm._v("fa-times")
              ]),
          _vm._v(" "),
          _c("br"),
          _vm.travelServiceOrderItem.car.end_place_id !== null
            ? [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("travelService.returnCarPlace")) +
                    ": " +
                    _vm._s(_vm.endPlaceText)
                ),
                _c("br")
              ]
            : _vm._e(),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.class")) +
              ": " +
              _vm._s(_vm.carClassTypeText) +
              " "
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.pickupDate")) +
              ": " +
              _vm._s(_vm.travelServiceOrderItem.car.start_date) +
              " " +
              _vm._s(_vm.travelServiceOrderItem.car.start_time)
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.returnCarDate")) +
              ": " +
              _vm._s(_vm.travelServiceOrderItem.car.end_date) +
              " " +
              _vm._s(_vm.travelServiceOrderItem.car.end_time)
          ),
          _c("br")
        ],
        2
      ),
      _c("travel-service-order-item-common-tooltip-part", {
        attrs: { "travel-service-order-item": _vm.travelServiceOrderItem }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }